'use client';
import { FC } from 'react';

import {
  MenubarContent,
  MenubarItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MenubarTrigger,
} from '@/components/ui/menubar';
import { ChevronDownIcon } from 'lucide-react';

import Link from 'next/link';
import { NavigationItemInterface } from '@/data/defaultValue';

interface NavigationItemProps {
  className?: string;
  menuItem: NavigationItemInterface;
}

const NavigationItem: FC<NavigationItemProps> = ({ menuItem }) => {
  const isDropdown =
    menuItem?.sub_categories && menuItem.sub_categories.length > 0;

  const renderDropdownMenu = (menuDropdown: NavigationItemInterface) => {
    return (
      <>
        {renderMainItem(menuDropdown)}
        <MenubarContent>
          {menuDropdown.sub_categories!.map((i, index) => {
            const isChileDropdown = i?.sub_categories
              ? i?.sub_categories.length > 0
              : false;
            if (isChileDropdown) {
              return (
                <div key={index}>{renderDropdownMenuNavlinkHasChild(i)}</div>
              );
            } else {
              return renderDropdownMenuNavlink(i, index);
            }
          })}
        </MenubarContent>
      </>
    );
  };

  const renderDropdownMenuNavlinkHasChild = (
    items: NavigationItemInterface,
  ) => {
    return (
      <>
        <MenubarSub>
          <MenubarSubTrigger>{items.name} </MenubarSubTrigger>
          <MenubarSubContent>
            {items?.sub_categories &&
              items.sub_categories.length > 0 &&
              items.sub_categories.map((i, index) => {
                const hasChild =
                  i?.sub_categories && i.sub_categories.length > 0;
                if (hasChild) {
                  return (
                    <div key={index}>
                      {renderDropdownMenuNavlinkHasChild(i)}
                    </div>
                  );
                }

                return (
                  <MenubarItem key={index} asChild>
                    {i?.href ? (
                      <Link href={`/category${i.href}`} className='cursor-pointer'>
                        {i.name}
                      </Link>
                    ) : (
                      i.name
                    )}
                  </MenubarItem>
                );
              })}
          </MenubarSubContent>
        </MenubarSub>
      </>
    );
  };

  const renderDropdownMenuNavlink = (
    item: NavigationItemInterface,
    index: number,
  ) => {
    return (
      <MenubarItem key={index} asChild>
        {item?.href ? (
          <Link href={`/category${item.href}`} className='cursor-pointer'>
            {item.name}
          </Link>
        ) : (
          item.name
        )}
      </MenubarItem>
    );
  };

  const renderMainItem = (item: NavigationItemInterface) => {
    return (
      <MenubarTrigger className='cursor-pointer'>
        {item?.href ? (
          <Link href={`/category${item.href}`} className='cursor-pointer'>
            {item.name}
          </Link>
        ) : (
          item.name
        )}
        {isDropdown && (
          <ChevronDownIcon
            className=' ml-1 mt-1  h-4 w-4 '
            aria-hidden='true'
          />
        )}
      </MenubarTrigger>
    );
  };

  if (isDropdown) {
    return renderDropdownMenu(menuItem);
  } else {
    return renderMainItem(menuItem);
  }
};

export default NavigationItem;
